/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DocumentTypeResource } from './';
import {
    DocumentTypeResourceFromJSON,
    DocumentTypeResourceFromJSONTyped,
    DocumentTypeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AffidavitSubmissionRequest
 */
export interface AffidavitSubmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof AffidavitSubmissionRequest
     */
    companyId: string;
    /**
     * 
     * @type {DocumentTypeResource}
     * @memberof AffidavitSubmissionRequest
     */
    documentType: DocumentTypeResource;
    /**
     * BCP 47 locale tag used to generate the affidavit PDF (e.g. "fr", "en")
     * @type {string}
     * @memberof AffidavitSubmissionRequest
     */
    locale: string;
}

/**
 * Check if a given object implements the AffidavitSubmissionRequest interface.
 */
export function instanceOfAffidavitSubmissionRequest(value: object): value is AffidavitSubmissionRequest {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    if (!('locale' in value) || value['locale'] === undefined) return false;
    return true;
}

export function AffidavitSubmissionRequestFromJSON(json: any): AffidavitSubmissionRequest {
    return AffidavitSubmissionRequestFromJSONTyped(json, false);
}

export function AffidavitSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffidavitSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'documentType': DocumentTypeResourceFromJSON(json['documentType']),
        'locale': json['locale'],
    };
}

export function AffidavitSubmissionRequestToJSON(value?: AffidavitSubmissionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'documentType': DocumentTypeResourceToJSON(value['documentType']),
        'locale': value['locale'],
    };
}

